
angular.module('bmsApp.crm.customer').factory('CustomerStatusSvc', function (CRUDSvc, CUSTOMER_STATUS_API) {

	return {
		options: function () {
			return CRUDSvc.get(CUSTOMER_STATUS_API.OPTIONS);
		}
	};

}).constant('CUSTOMER_STATUS_API', {
	OPTIONS: 'api/customerStatus/options'
});
